import { Link, Navigate, useNavigate } from 'react-router-dom';
import { IonosLogo } from '@/modules/user-feedback/components/ionos-logo';
import { useAdminAuth } from '../context/AdminAuthContext';

export function AdminLayout({ children }: { children: React.ReactNode }) {
	const { user, logout } = useAdminAuth();
	const navigate = useNavigate();

	const handleLogout = async () => {
		await logout();
		navigate('/');
	};

	return (
		<div className='min-h-screen bg-background'>
			<header className='border-b border-border bg-card px-8 py-4'>
				<div className='max-w-6xl mx-auto flex items-center justify-between'>
					<Link to='/admin' className='flex items-center gap-4'>
						<IonosLogo />
						<span className='text-xl font-light text-foreground/70 tracking-[-0.01em]'>
							Feature Request Administration
						</span>
					</Link>
					{user && (
						<div className='flex items-center gap-4'>
							<span className='text-sm text-muted-foreground'>
								{user.email}
							</span>
							<button
								type='button'
								onClick={handleLogout}
								className='text-sm text-muted-foreground hover:text-foreground transition-colors cursor-pointer'
							>
								Sign out
							</button>
						</div>
					)}
				</div>
			</header>
			<main className='px-8 py-8'>
				<div className='max-w-6xl mx-auto'>{children}</div>
			</main>
		</div>
	);
}

export function AdminGuardedRoute({ children }: { children: React.ReactNode }) {
	const { user, loading } = useAdminAuth();

	if (loading) {
		return (
			<div className='min-h-screen bg-background flex items-center justify-center'>
				<div className='w-8 h-8 rounded-full border-2 border-primary border-t-transparent animate-spin' />
			</div>
		);
	}

	if (!user) {
		return <Navigate to='/' replace />;
	}

	return <>{children}</>;
}
